import { Box, ScreenLoader, useMediaQuery } from "components/common";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import MainDrawer from "./drawer";
import Header from "./header";
import useFunctions from "./ts/useFunctions";

import Footer from "components/layouts/footer";
import LoginDialog from "pages/auth";
import { theme } from "theme";

export default function MainLayout() {
  const { pathname, headerHeight } = useFunctions();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));

  const hideFooterOnPathname = ["/cart", "/checkout"];

  const shouldHideFooter =
    hideFooterOnPathname.includes(pathname) ||
    pathname.startsWith("/products") ||
    pathname.startsWith("/product-details");
  return (
    <>
      <Box position="fixed" top={0} width="100%" zIndex={10000}>
        <Box
          bgcolor="black"
          textAlign="center"
          fontSize="16px"
          color="white"
          margin="auto"
          width="fit-content"
          p={1}
        >
          Free shipping over $99!
        </Box>
      </Box>
      <Header />
      {matchDownMD && <MainDrawer />}
      <Box
        component="main"
        sx={{
          width: "100%",
          maxWidth: 2000,
          margin: "auto",
          mt: `${headerHeight}px`,
        }}
      >
        <Suspense fallback={<ScreenLoader />}>
          <Outlet />
        </Suspense>
      </Box>
      {!shouldHideFooter && <Footer />}

      <LoginDialog />
    </>
  );
}
